export const injectParamsToPath = (path: string, params: Record<string, string | number | boolean>) =>
    path.replace(/:([\w]+)/g, (_, key) => {
        if (params[key]) {
            return encodeURIComponent(params[key]);
        }

        return `:${key}`;
    });
